fx.ns("shared.stage", class CalendarCell extends shared.stage.BaseCalendarCell {
    constructor(data, day, model) {
        super(data, day, model);
    }

    get text() {
        if (this.data && this.data.content) {
            let content = JSON.parse(this.data.content);
            return content.days[this.day] || "";
        }
        else
            return "";
    }

    get currentText() {
        return this.input.value;
    }

    updateDate(data, day) {
        this.data = data;
        this._day = day;

        this.dayComponent.text = this.day;
        this.input.value = this.text;
        this.onInputUpdated();
        this.updateDisplay();
        this.delay(this.focus, 250);
    }

    /**
     * Component initialization.
     */
    create() {
        super.create();

        this.dayComponent.viewport({ top: 2 * this.creation.extraScale, right: 2 * this.creation.extraScale });
        this.dayComponent.css({ fontSize: 3 * this.creation.extraScale + "px" });

        this.input = new fx.components.TextAreaAdvanced({ value: this.text, className: "text", maxlength: 60, rows: 3 });
        this.input.css({ fontSize: 2.5 * this.creation.extraScale + "px" });
        this.addChild(this.input, { left: "center", top: "center", width: "90%" });

        this.addChild(new fx.components.Image({ data: fx.assets.editIcon, className: "plus" }), { width: this.width() * 0.7, height: this.height() * 0.7, top: "center", left: "center" });

        this.toolTip = this.day;
        this.toolTypeStyle = { position: "top", positionMargin: -1, class: "CalendarCell" };
    }



    onReady() {
        super.onReady();

        this.on("height-updated", this.onInputUpdated, this.input);

        this.onInputUpdated();
    }

    onInputUpdated() {
        this.input.attr("lines", this.input.numRows);

        this.updateDisplay();
    }

    onDataUpdated(action) {
        if (action.type == "update") {
            this.input.value = this.text;
            this.onInputUpdated();
        }

    }

    focus(positionAtEnd) {
        this.input.focus(positionAtEnd)
    }


});